import {SupportedLocales} from '#types/locale.js';

export const LOCALE_DEFAULT = SupportedLocales.EN;

export class Locale {
  current: SupportedLocales = this.getLocale();

  getLocale() {
    if (navigator.languages) {
      const browserLocale: string = navigator.language.split('-')[0];
      return this.getSupportedLocaleForValue(browserLocale);
    }
    return LOCALE_DEFAULT;
  }

  getSupportedLocaleForValue(value: unknown): SupportedLocales {
    if (
      typeof value === 'string' &&
      Object.values<string>(SupportedLocales).includes(value)
    ) {
      return value as SupportedLocales;
    }
    console.warn(
      `[${value}] is not a supported locale. Falling back to default [${LOCALE_DEFAULT}]`
    );
    return LOCALE_DEFAULT;
  }
}

export const locale = new Locale();
